import React from 'react';
import SIcon from './SIcon';
import { faExchange } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faExchange} fa />;

export default Icon;
